import React, { useEffect, useState } from "react";
import Card from "components/card";
import { getDocuments } from "services/documents";

const UserDocuments: React.FC = () => {
  const [documents, setDocuments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await getDocuments();
        const list = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data)
          ? data
          : [];
        if (mounted) setDocuments(list);
      } catch (err) {
        console.error(err);
        if (mounted) setDocuments([]);
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Card extra="w-full p-4">
      <div className="mb-4">
        <h1 className="text-2xl font-bold">Documents</h1>
        <p className="text-sm text-gray-500">
          Documents shared with your account
        </p>
      </div>

      {loading ? (
        <div>Loading...</div>
      ) : documents.length === 0 ? (
        <div className="text-sm text-gray-500">No documents available</div>
      ) : (
        <div className="space-y-3">
          {documents.map((doc) => (
            <div
              key={doc.id}
              className="flex items-center justify-between rounded bg-white p-3 shadow-sm dark:bg-navy-700"
            >
              <div>
                <div className="font-semibold">{doc.title}</div>
                <div className="text-sm text-gray-500">{doc.description}</div>
              </div>
              <div>
                <a
                  href={doc.download_url || `/storage/${doc.file_path}`}
                  className="text-indigo-600"
                >
                  Download
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default UserDocuments;
